/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI73402ReqOrderObjectsItem {
  
  /**  */
  orderByColumn?: string;
  
  /**  */
  orderByDesc?: boolean;
  
};
    
  
    
export interface IAPI73402ResListItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export type IAPI73402ResListItemOtherDataObjMapValueObj = {};
    
  
    
export interface IAPI73402ResListItemOtherDataObj {
  
  /** String */
  mapKey?: IAPI73402ResListItemOtherDataObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI73402ResListItemOtherDataObjMapValueObj;
  
};
    
  
    
export interface IAPI73402ResListItemTreeDataItem {
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 岗位名称 */
  jobName?: string;
  
};
    
  
    
export interface IAPI73402ResListItem {
  
  /**  */
  id?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI73402ResListItemActionsItem[];
  
  /**  */
  timesTotal?: number;
  
  /**  */
  timesLeft?: number;
  
  /**  */
  isLine?: boolean;
  
  /** (该参数为map) */
  otherData?: IAPI73402ResListItemOtherDataObj;
  
  /**  */
  sessionToken?: string;
  
  /** TreeNodeResult */
  treeData?: IAPI73402ResListItemTreeDataItem[];
  
};
    
  



export interface API73402Req {
  
  /** 场景 */
  scenes: string;
  /** 子场景:业务带 */
  subScenes: string;
  /** 会话标识Id */
  sessionToken: string;
  /**  */
  pageSize: string;
  /**  */
  pageIndex: string;
  /**  */
  rowId: string;
  /**  */
  jumpType: string;
  /**  */
  searchCount: string;
  /**  */
  orderObjects: string;
  /** 场景 */
  scenes?: string;
  /** 子场景:业务带 */
  subScenes?: string;
  /** 会话标识Id */
  sessionToken: string;
  /**  */
  pageSize?: number;
  /**  */
  pageIndex?: number;
  /**  */
  rowId?: string;
  /**  */
  jumpType?: number;
  /**  */
  searchCount?: boolean;
  /** OrderByColumn */
  orderObjects?: IAPI73402ReqOrderObjectsItem[];
};



export interface API73402Res {
  /** T  */
  list?: IAPI73402ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 73402 查询分页聊天记录

export interface IUsePostAPI73402Return {
  /** 查询分页聊天记录: 接口请求状态 */
  isAPI73402Loading: boolean;
  /** 查询分页聊天记录: 接口请求返回数据 */
  dataAPI73402: API73402Res;
  /**  查询分页聊天记录: 接口数据请求方法 */
  fetchAPI73402Data: (inputs: API73402Req, config?: YWRequestConfig) => Promise<API73402Res>;
  /** 查询分页聊天记录: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI73402 = ():IUsePostAPI73402Return => {
  let isMount = true;
  const [isAPI73402Loading, setIsAPI73402Loading] = useState(false);
  const [dataAPI73402, setDataAPI73402] = useState<API73402Res>({} as API73402Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/record/query`;

  const fetchAPI73402Data = async (inputs: API73402Req, config?: YWRequestConfig): Promise<API73402Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API73402Req>) || {}) as API73402Req;
    
  
    if ( isMount ) {
      setIsAPI73402Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API73402Res>(`${basePath}/yoaichat-web/chat/record/query`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI73402(res || {} as API73402Res);
        setIsAPI73402Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI73402Loading(false);
      }
      return false as unknown as API73402Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI73402Loading,
    dataAPI73402,
    fetchAPI73402Data,
    requestUrl,
  }
}

